<template>
    <div :class="classes">
        <div v-if="illustration" class="kpi-item__illustration">
            <img :src="illustration" :alt="label" class="kpi-item__illustration-image" />
        </div>
        <div class="kpi-item__content">
            <div v-if="!hideTitle" class="kpi-item__label typographies-paragraph-x-small-regular">
                {{ label }}
            </div>
            <div class="kpi-item__value typographies-paragraph-large-bold">
                {{ value }}
                <span
                    v-if="suffix"
                    class="kpi-item__suffix typographies-paragraph-x-small-bold"
                >
                    {{ $t.__(suffix) }}
                </span>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    props: {
        id: {
            type: String,
            required: true,
        },
        label: {
            type: String,
            required: true,
        },
        suffix: {
            type: String,
            default: '',
        },
        value: {
            type: String,
            required: true,
        },
        illustration: {
            type: String,
            default: '',
        },
        hideTitle: {
            type: Boolean,
            default: false,
        },
    },
    computed: {
        classes() {
            return ['kpi-item', `kpi-item--${this.id}`];
        },
    },
};
</script>
<style scoped lang="scss">
.kpi-item {
    align-items: center;
    display: flex;
    gap: var(--spacing-1);
    min-width: 120px;

    &__illustration {
        flex: 0 0 auto;
        height: var(--spacing-5);
        width: var(--spacing-5);
    }

    &__label {
        color: var(--colors-common-text-subtle-default);
        margin: 0 0 2px;
        text-transform: uppercase;
    }

    &__value {
        align-items: center;
        color: var(--colors-common-text-standard-default);
        display: flex;
        gap: var(--spacing-0);
    }

    &__suffix {
        color: var(--colors-common-text-standard-caption);
        text-transform: uppercase;
    }
}
</style>
